import { render, staticRenderFns } from "./addJoin.vue?vue&type=template&id=354d69ee&scoped=true&"
import script from "./addJoin.vue?vue&type=script&lang=js&"
export * from "./addJoin.vue?vue&type=script&lang=js&"
import style0 from "./addJoin.vue?vue&type=style&index=0&id=354d69ee&lang=scss&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "354d69ee",
  null
  
)

export default component.exports